<template>
  <sl-page title="下发命令">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="类型" prop="type">
        <RadioGroup v-model="form.type">
          <Radio label="imei">车辆IMEI</Radio>
          <Radio label="carNos">车辆编号</Radio>
          <Radio label="companyId">企业</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="label" prop="value">
        <Input v-if="form.type!='companyId'" :placeholder="placeholder" v-model="form.value" />
        <sl-select v-else :full-props="true" dict="company" @on-change="handleChange" :filterable="true" v-model="form.value" />
      </FormItem>
      <FormItem label="命令" prop="cmd">
        <Input v-model="form.cmd" />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('form')">确定</Button>
      </FormItem>
    </Form>
  </sl-page>
</template>
<script>
export default {
  // left315 x top370  168x168
  data() {
    return {
      rules: {
        carNos: [{ required: true, message: '车辆编号不能为空', trigger: 'blur,change' }],
        cmd: [{ required: true, message: '命令不能为空', trigger: 'blur,change' }],
      },
      form: {
        type:'imei',
        value:null,
        cmd: null,
      },
      loading: false,
      selectCompany:null,
      modalVisible: false,
    }
  },

  computed: {
    label(){
      switch(this.form.type){
        case 'imei':
          return '车辆IMEI'
        case 'carNos':
          return '车辆编号'
        case 'companyId':
          return '所属企业'
        default:
          return ''
      }
    },
    placeholder(){
      return '请输入'+this.label+(this.form.type == 'carNos' ? '，多个请用,分隔':'')
    },
    tips(){
      let u = { 'imei':'imei为{key}的车辆' , 'carNos':'编号为{key}的车辆' , 'companyId':'{selectCompany} 关联车辆'}
      let h = u[this.form.type]
      if(h){
        return h.replace('{key}',this.form.value).replace('{selectCompany}',this.selectCompany)
      }
    }
  },

  watch:{
    'form.type'(){
      this.form.value = null
    }
  },

  mounted() {},

  methods: {
    init(id) {
      if (id) {
        this.$refs['form'].resetFields()
        this.modalVisible = true
      }
    },

    save() {
      let value = this.form.value
      let type = this.form.type
      
      if(type == 'carNos'){
        value = this.form.value.split(',')
        //type = 'carNo'
      }

      let params = { cmd: this.form.cmd, [type]: value }
      let tips = this.tips
      this.loading = true
      this.$ui.confirm(this.$request.deviceCmd, `确定向  ${tips} 下发 ${this.form.cmd}？`)(params).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
        } else {
          this.$Notice.error({
            title: '发生错误',
            desc: resp.msg,
          });
        }
        this.loading = false

      })

    },
    handleSubmit(name) {

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleChange(v){
      this.selectCompany = v.label
    }
  }
}

</script>
